import EventEditTeamList from '-/Event/EventEditTeamList';
import EventEditTeamSearch from '-/Event/EventEditTeamSearch';
import { useFormContext, useWatch } from 'react-hook-form';
import * as EntityListCount from '@/components/Entity/EntityListCount';
import Box from '@/components/UI/Box';
import { MAXIMUM_EVENT_TEAM_COUNT } from '@/utils/constants';
import type { EventEditFormValues } from './EventEdit.types';

function EventEditTeam() {
  const { control } = useFormContext<EventEditFormValues>();
  const teams = useWatch({
    name: 'teams',
    control,
  });
  return (
    <>
      <EntityListCount.Container>
        <EntityListCount.Heading name="teams" />
        <EntityListCount.Input
          name="teams"
          maxEntities={MAXIMUM_EVENT_TEAM_COUNT}
        />
      </EntityListCount.Container>
      {teams?.length ? (
        <>
          <EventEditTeamSearch />
          <Box background="divider" height={2} />
          <EventEditTeamList />
        </>
      ) : null}
    </>
  );
}
export default EventEditTeam;
